module.exports = __webpack_public_path__ + "img/уральская деревня 60х90.aa546fdd.jpg";